import { render, staticRenderFns } from "./PromoBarF.vue?vue&type=template&id=40996c32&scoped=true&"
import script from "./PromoBarF.vue?vue&type=script&lang=js&"
export * from "./PromoBarF.vue?vue&type=script&lang=js&"
import style0 from "./PromoBarF.vue?vue&type=style&index=0&id=40996c32&prod&lang=css&"
import style1 from "./PromoBarF.vue?vue&type=style&index=1&id=40996c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40996c32",
  null
  
)

export default component.exports